import { SmartTableColumn, WithNAFallback } from '@toggle/design-system';
import { EarningsInsightRating, RecapKpi } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { RatingPill } from '~/widgets/earnings-insight-drawer/earnings-insight-widget/components/rating-pill/RatingPill';
import { SharedTable } from '~/widgets/earnings-insight-drawer/earnings-insight-widget/components/shared-table/SharedTable';
import styles from './KpisTable.module.scss';

interface KpisTableProps {
  kpisData: RecapKpi[];
}

export const KpisTable = ({ kpisData }: KpisTableProps) => {
  const { t } = useTranslation(['earnings']);

  const tableData = (kpisData || []).map((item, index) => ({
    ...item,
    key: `kpi-${index}`,
  }));

  const tableColumns: SmartTableColumn<RecapKpi>[] = [
    {
      key: 'title',
      label: t('earningsInsight.drawer.earningsRecap.tables.kpi'),
      render: (value: string) => (
        <WithNAFallback
          check={value !== undefined && value !== ''}
          value={<div className={styles.styledTitleCell}>{value}</div>}
        />
      ),
    },
    {
      key: 'value',
      label: t('earningsInsight.drawer.earningsRecap.tables.value'),
      render: (value: string) => (
        <WithNAFallback
          check={value !== undefined && value !== ''}
          value={<div className={styles.valueCell}>{value}</div>}
        />
      ),
    },
    {
      key: 'description',
      label: t('earningsInsight.drawer.earningsRecap.tables.description'),
      render: (value: string) => (
        <WithNAFallback
          value={
            value && <div className={styles.styledDescriptionCell}>{value}</div>
          }
        />
      ),
    },
    {
      key: 'rating',
      label: t('earningsInsight.drawer.earningsRecap.tables.impact'),
      render: (value?: EarningsInsightRating) => (
        <WithNAFallback
          value={
            value && (
              <div className={styles.styledRatingPill}>
                <RatingPill rating={value} />
              </div>
            )
          }
        />
      ),
    },
  ];

  return (
    <>
      <h2 className={styles.title}>
        {t('earnings:earningsInsight.drawer.earningsRecap.items.kpisInFocus')}
      </h2>
      <SharedTable
        tableData={tableData}
        tableColumns={tableColumns}
        noCellPadding
      />
    </>
  );
};
